import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'recompose';
import { createStyles, IconButton, Typography } from '@material-ui/core';
import { border } from '@topconagriculture/theme';
import { withBaseProps } from '../../../../Utils';
const styles = (theme) => createStyles({
    leftBorderRadius: {
        borderRadius: '50% 0 0 50%',
    },
    rightBorderRadius: {
        borderRadius: '0 50% 50% 0',
    },
    buttonContainer: {
        display: 'flex',
    },
    button: {
        height: 36,
        width: 36,
        padding: 0,
    },
    buttonText: {
        lineHeight: theme.font.lineHeight.mediumBig,
    },
    outlined: {
        border: border(theme.color.brand.dark, 1, 'solid'),
    },
    filled: {
        backgroundColor: theme.color.brand.main,
        color: theme.color.font.light,
    },
    highlighted: {
        backgroundColor: theme.color.brand.lightest,
    },
    lightText: {
        color: theme.color.font.light,
    },
    darkText: {
        color: theme.color.font.dark,
    },
});
const DateRangePickerComponentDay = (props) => {
    const { classes, startOfRange, endOfRange, isNotInRange, isSameMonth, highlighted, outlined, filled, onClick, onHover, value, } = props;
    const disabled = !isSameMonth || isNotInRange;
    return (React.createElement("div", { className: classNames(classes.buttonContainer, startOfRange && classes.leftBorderRadius, endOfRange && classes.rightBorderRadius, !disabled && highlighted && classes.highlighted) },
        React.createElement(IconButton, { className: classNames(classes.button, !disabled && outlined && classes.outlined, !disabled && filled && classes.filled), disabled: disabled, onClick: onClick, onMouseOver: onHover },
            React.createElement(Typography, { className: classNames(classes.buttonText, !disabled && !filled && classes.darkText, ((!disabled && filled) || !isSameMonth) && classes.lightText), variant: "body2" }, value))));
};
export default compose(withBaseProps({ styles }))(DateRangePickerComponentDay);
//# sourceMappingURL=DateRangePickerComponentDay.js.map